import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../../axios-backend";
import BackButton from "../../main/BackButton";
import ClickHere from "../../main/ClickHere";
import Line from "../../main/Line";
import classes from "../css/Authentication.module.css";

const Transfer = (props) => {
  const navigate = useNavigate();
  const md5 = require("md5");
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");

  useEffect(() => {
    if (sessionStorage["isAuth"]) {
      axios
        .get("/authenticationcard/", {
          params: {
            cardNumber: sessionStorage["cardNumber"],
            password: sessionStorage["password"],
          },
        })
        .then((data) => {
          if (data.data.status === 200) {
            // Don't auto-populate email field - leave it blank
          } else {
            alert("sorry. something is wrong.");
            navigate("/home");
          }
        })
        .catch((error) => {
          alert("sorry. something is wrong.");
          navigate("/home");
        });
    } else {
      navigate("/home");
    }
  }, [navigate]);

  const clickHandle = () => {
    const times = sessionStorage["transferTry"];
    if (times > 3) {
      alert(`sorry, you have tried too many times today. please try tomorrow.`);
      return;
    }
    const inputValidation = email && pwd;

    const validate = (email) => {
      const expression = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return expression.test(String(email).toLowerCase());
    };

    if (!validate(email) || !inputValidation) {
      window.alert("please input correct information");
      return;
    } else {
      const result = window.confirm(
        `are you sure you want to transfer ownership of this product to ${email}? if you transfer ownership, you will no longer be the owner of this product.`
      );
      if (result) {
        axios
          .post("/transfer-auth", {
            cardNumber: sessionStorage["cardNumber"],
            pid: sessionStorage["transfer"],
            email: email.trim(),
            pwd: md5(pwd.trim()),
          })
          .then((data) => {
            if (data.data.status === 200) {
              sessionStorage.removeItem("cardNumber");
              sessionStorage.removeItem("transfer");
              sessionStorage.removeItem("password");
              sessionStorage.removeItem("isAuth");
              navigate("/authenticity/finish");
            } else if (data.data.status === 400) {
              alert("Transfer declined. Check the password");
            } else {
              sessionStorage["transferTry"] = times ? parseInt(times) + 1 : 1;
            }
          });
      }
    }
  };

  return (
    <>
      <BackButton />
      <Line type="empty-line">
        <span className={classes.span}>Enter your password here</span>
      </Line>
      <Line type="bottom-line">
        <input
          type="text"
          maxLength="16"
          className={classes.textbox}
          value={pwd}
          onChange={(e) => {
            setPwd(e.target.value);
          }}
        />
      </Line>
      <Line type="empty-line">
        <span className={classes.span}>Enter email of new owner here</span>
      </Line>
      <Line type="bottom-line">
        <input
          type="text"
          className={classes.textbox}
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
      </Line>
      <Line type="bottom-line" />
      <Line type="bottom-line">
        confirm <ClickHere onClick={clickHandle} />
      </Line>
      <Line type="bottom-line" />
      <Line type="bottom-line" />
      <Line type="bottom-line" />
      <Line type="bottom-line" />
      <Line type="bottom-line" />
    </>
  );
}

export default Transfer;
